import { SVGProps } from "react";

export function CheckSuccessIllustration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={88} height={88} viewBox="0 0 88 88" fill="none" {...props}>
      <mask
        id="check-success-mask"
        width={72}
        height={72}
        x={8}
        y={8}
        maskUnits="userSpaceOnUse"
      >
        <circle cx={44} cy={44} r={36} fill="#F9F8F8" />
      </mask>
      <g mask="url(#check-success-mask)">
        <circle cx={44} cy={44} r={36} fill="#DEDFE0" opacity={0.2} />
        <rect width={60} height={18} x={14} y={62} fill="#92C9B5" rx={2} />
        <path
          fill="#1F9E80"
          d="m22.438 71.678-.875-.875a.411.411 0 0 0-.302-.125.411.411 0 0 0-.302.125.435.435 0 0 0-.136.318c0 .122.042.224.125.307l1.167 1.167a.43.43 0 0 0 .625 0l2.323-2.323c.076-.076.095-.168.057-.276a.975.975 0 0 1-.057-.328.417.417 0 0 0-.307-.125.417.417 0 0 0-.308.125l-2.01 2.01Zm.562 3.49c-.576 0-1.118-.11-1.625-.328a4.206 4.206 0 0 1-1.323-.89 4.21 4.21 0 0 1-.89-1.324 4.058 4.058 0 0 1-.328-1.625c0-.576.109-1.118.328-1.625.219-.507.515-.948.89-1.323a4.208 4.208 0 0 1 1.323-.89A4.058 4.058 0 0 1 23 66.835c.577 0 1.118.109 1.625.328a4.21 4.21 0 0 1 1.323.89c.375.375.672.816.89 1.323.22.507.329 1.049.329 1.625 0 .577-.11 1.118-.328 1.625a4.207 4.207 0 0 1-.89 1.323 4.207 4.207 0 0 1-1.324.89 4.057 4.057 0 0 1-1.625.329Z"
        />
        <rect
          width={22}
          height={3}
          x={30}
          y={67}
          fill="#F7F8F8"
          opacity={0.9}
          rx={1}
        />
        <rect
          width={40}
          height={3}
          x={30}
          y={72}
          fill="#F7F8F8"
          opacity={0.6}
          rx={1}
        />
      </g>
      <rect width={68} height={20} x={10} y={17} fill="#1F9E80" rx={2} />
      <path
        fill="#F7F8F8"
        d="m19.325 27.814-1.05-1.05c-.1-.1-.22-.15-.362-.15a.494.494 0 0 0-.363.15.522.522 0 0 0-.162.381c0 .146.05.269.15.369l1.4 1.4a.515.515 0 0 0 .75 0l2.787-2.788c.092-.091.115-.202.07-.33a1.17 1.17 0 0 1-.07-.395.501.501 0 0 0-.368-.15.501.501 0 0 0-.37.15l-2.412 2.413ZM20 32a4.869 4.869 0 0 1-1.95-.393 5.049 5.049 0 0 1-1.587-1.07c-.45-.45-.806-.978-1.069-1.587a4.869 4.869 0 0 1-.394-1.95c0-.691.132-1.341.394-1.95a5.05 5.05 0 0 1 1.069-1.587c.45-.45.979-.806 1.587-1.069a4.869 4.869 0 0 1 1.95-.394 4.87 4.87 0 0 1 1.95.394 5.05 5.05 0 0 1 1.588 1.069c.45.45.806.98 1.069 1.587a4.87 4.87 0 0 1 .393 1.95c0 .692-.13 1.342-.393 1.95a5.048 5.048 0 0 1-1.07 1.588c-.45.45-.978.806-1.587 1.069A4.87 4.87 0 0 1 20 32Z"
      />
      <rect
        width={22}
        height={3}
        x={28}
        y={23}
        fill="#F7F8F8"
        opacity={0.9}
        rx={1}
      />
      <rect
        width={46}
        height={3}
        x={28}
        y={28}
        fill="#F7F8F8"
        opacity={0.6}
        rx={1}
      />
      <rect width={60} height={18} x={14} y={41} fill="#92C9B5" rx={2} />
      <path
        fill="#1F9E80"
        d="m22.438 50.678-.875-.875a.411.411 0 0 0-.302-.125.411.411 0 0 0-.302.125.435.435 0 0 0-.136.318c0 .121.042.224.125.307l1.167 1.167a.43.43 0 0 0 .625 0l2.323-2.323c.076-.076.095-.168.057-.276a.975.975 0 0 1-.057-.328.417.417 0 0 0-.307-.125.417.417 0 0 0-.308.125l-2.01 2.01Zm.562 3.49c-.576 0-1.118-.11-1.625-.328a4.206 4.206 0 0 1-1.323-.89 4.21 4.21 0 0 1-.89-1.324 4.058 4.058 0 0 1-.328-1.625c0-.576.109-1.118.328-1.625.219-.507.515-.948.89-1.323a4.208 4.208 0 0 1 1.323-.89A4.058 4.058 0 0 1 23 45.835c.577 0 1.118.109 1.625.328a4.21 4.21 0 0 1 1.323.89c.375.375.672.816.89 1.323.22.507.329 1.049.329 1.625 0 .577-.11 1.118-.328 1.625a4.207 4.207 0 0 1-.89 1.323 4.207 4.207 0 0 1-1.324.89 4.057 4.057 0 0 1-1.625.329Z"
      />
      <rect
        width={22}
        height={3}
        x={30}
        y={46}
        fill="#F7F8F8"
        opacity={0.9}
        rx={1}
      />
      <rect
        width={40}
        height={3}
        x={30}
        y={51}
        fill="#F7F8F8"
        opacity={0.6}
        rx={1}
      />
      <defs />
    </svg>
  );
}
